import React from 'react';
import styled from 'styled-components';
import Div from '../common/Div';

export default function Image(props) {
  const Image = styled.img``;

  return (
    <Div width={props.width} height={props.height}>
      <Image
        src={props.src}
        alt={props.alt}
        width={'100%'}
        height={props.height||'auto'}
        max-width={props.width}
        max-height={props.height}
        object-fit={props.objectFit}
      >
        {props.children}
      </Image>
    </Div>
  );
}
